import CloseIcon from '@mui/icons-material/Close';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Popover,
  Stack,
  Switch,
  TextField,
  Typography,
  IconButton,
} from '@mui/material';
import 'ace-builds/src-noconflict/mode-java';
import 'ace-builds/src-noconflict/theme-github';
import 'brace/ext/searchbox';
import { useEffect, useRef, useState, useCallback } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import client from '../common/client.js';

import {
  DataGrid,
  GridRowId,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridRowModes
} from '@mui/x-data-grid';

export default function IDELanguage(props) {
  const navigate = useNavigate();
  const fileInput = useRef();
  const [loading, setLoading] = useState(false)
  const [inited, setInited] = useState(false)

  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState('');
  const [popupLabel, setPopupLabel] = useState('');
  const [buttonName, setButtonName] = useState('');
  const [popoverLoading, setPopoverLoading] = useState(false);

  const [list, setList] = useState([])
  const [rows, setRows] = useState([])
  const [columns, setColumns] = useState([])

  const [rowModesModel, setRowModesModel] = useState({});

  const [onlyScreen, setOnlyScreen] = useState(false)
  const [showCandidate, setShowCandidate] = useState(true)
  const [untransed, setUntransed] = useState(false)
  const [keyword, setKeyword] = useState('')
  const [language_list, setlanguage_list] = useState([])
  const [collectProd, setcollectProd] = useState(false)

  useEffect(() => {
    update()
  }, [props.project_id])

  useEffect(() => {
    if(props.block_id && list.length > 0) {
      filterList()
    }
  }, [props.block_id])

  const filterList = useCallback(() => {

    let new_list = [...list]
    if(onlyScreen)
      new_list = new_list.filter(f=>f.block_id == props.block_id)

    if(keyword)
      new_list = new_list.filter(f=>f.key.includes(keyword))

    if(!showCandidate)
      new_list = new_list.filter(f=>f.type != 'candidate')
    
    if(untransed)
      new_list = new_list.filter(f=>{
        let blank = false
        language_list.map(m=>{
          if(!f[m.lang])
            blank = true
        })
        return blank
      })

    new_list.map(m=>{
      m.id = m._id
    })
    return new_list
  }, [onlyScreen, keyword, showCandidate, untransed, list])

  const handleDeleteClick = (id) => () => {
    console.log('handleDeleteClick', id, list.length)
  };

  const update = async (disableLoading) => {

    if(!disableLoading)
      setLoading(true)
    const res = await client.request_get('/api/language/' + props.project_id)
    setLoading(false)
    if (res.r) {
      setInited(true)
      const columns_list = [
        // { field: 'actions', type: 'actions', headerName: 'Actions',
        //   cellClassName: 'actions',
        //   width: 100, editable: false, 
        //   getActions: ({ id, row }) => {
        //     return [
        //       <GridActionsCellItem icon={<GTranslateIcon />} label="Translate" onClick={() => {translateRow(id, row.type)}} />,
        //       <GridActionsCellItem icon={<CloseIcon />} label="Remove" 
        //         onClick={handleDeleteClick(id)}
        //         // onClick={
        //         //   removeRow
        //         // }
        //       />,
        //     ];
        //   }
        // },
        { field: 'action', headerName: 'Action', width: 100, editable: false, 
          renderCell: params => 
          <Stack direction={'row'} spacing={1}>
            <IconButton edge="end" onClick={()=>{translateRow(params.id, params.row.type)}}><GTranslateIcon /></IconButton>
            <IconButton edge="end" onClick={()=>{removeRow(params.id)}}><CloseIcon /></IconButton>
          </Stack>, 
        },

        { field: 'block_name', headerName: 'Block', width: 150, editable: false },
        { field: 'node', headerName: 'Node', width: 100, editable: false },
        { field: 'type', headerName: 'Type', width: 100, editable: false, 
          renderCell: params => <Chip label={params.value}></Chip>, 
        },
        { field: 'key', headerName: 'Key', width: 550, editable: true },
        ...res.language_list.map(m=>{
          return { field: m.lang, headerName: m.lang, width: 350, editable: true }
        })]

      
      setList(res.list)
      setlanguage_list(res.language_list)
      setcollectProd(res.language_collect_prod)
      setColumns(columns_list)
    }
  }

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    client.request_post('/api/language/update', { ...newRow, project_id: parseInt(props.project_id) }).then(res => {
      update()

      if(res && res.r)
        toast.success('Saved')
      else if(res)
        toast.error(res.msg)
      else 
        toast.error('Failed')
    })
    return updatedRow;
  }

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut
      || params.reason === GridRowEditStopReasons.tabKeyDown
      || params.reason === GridRowEditStopReasons.enterKeyDown) {
      event.defaultMuiPrevented = false;
      setRowModesModel({ ...rowModesModel, [params.id]: { mode: GridRowModes.View } });
    }
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handlePopoverClose = () => {
    setOpen(false);
  }

  const handlePopoverAddOrRemove = () => {
    // console.log('handlePopoverAddOrRemove', value, buttonName)
    if (!value)
      return

    if (buttonName == 'add') {
      client.request_post('/api/language/add', { project_id: parseInt(props.project_id), lang: value })
        .then(res => {
        if(res && res.r) {
          handlePopoverClose()
          update()
        } else {
          toast.error(res.msg)
        }
      })
    } else if (buttonName == 'remove') {
      client.request_post('/api/language/remove', { project_id: parseInt(props.project_id), lang: value })
        .then(res => {
        if(res && res.r) {
          handlePopoverClose()
          update()
        } else {
          toast.error(res.msg)
        }
      })
    } else if (buttonName == 'add row') {
      client.request_post('/api/language/key/add', { project_id: parseInt(props.project_id), 
        key: value, block_id: props.block_id })
        .then(res => {
        if(res && res.r) {
          handlePopoverClose()
          update()
        } else {
          toast.error(res.msg)
        }
      })
    }
  }

  const changeOnlyScreen = (e) => {
    setOnlyScreen(e.target.checked)
    filterList()
    props.onChangeOption('block', e.target.checked)
  }

  const changeCandidate = (e) => {
    setShowCandidate(e.target.checked)
    filterList()
  }
  const changeUntransed = (e) => {
    setUntransed(e.target.checked)
    filterList()
  }

  const init = () => {
    client.request_post('/api/language/on', { project_id: parseInt(props.project_id) }).then(res => {
      if (res.r) {
        setInited(true)
        update()
      }
    })
  }

  const translateRow = async (id, type) => {
    const res = await client.request_post('/api/language/translate', { project_id: parseInt(props.project_id), 
      id, 
      type 
    })
    if (res.r) {
      toast.success('Translated')
      // const row = rows.find(f=>f.id == id)
      // if(!row) {
      //   console.log('rows', rows, list)
      //   return
      // }
      // Object.keys(res.result).map(lang=>{
      //   row[lang] = res.result[lang]
      // })
      
      // setRows([...rows])
      update(true)
      
    } else {
      toast.error(res.msg)
    }

  }

  const removeRow = async (id) => {
    const res = await client.request_post('/api/language/key/remove', { 
      project_id: parseInt(props.project_id), 
      id})

    if(res && res.r) {
      toast.success('Removed')
      // setList(list.filter(f=>f.id != id))
      // setRows(rows.filter(f=>f.id != id))
      update(true)
    } else {
      toast.error(res.msg)
    }
  }

  const generate = () => {
    client.request_post('/api/language/generate', { project_id: parseInt(props.project_id) }).then(res => {
      if (res.r) {
        toast.success('Generated From Sketch')
        update(true)
      } else {
        toast.error(res.msg)
      }
    })
  }

  const csv_download = () => {
    client.request_get('/api/language/download/' + props.project_id, {}).then(res => {
      window.open(res.url)
    })
  }

  const csv_upload = async (files) => {
    if(!files || files.length == 0)
      return
    
    const file = files[0];

    const fileBuffer = await file.arrayBuffer();
    console.log('csv_upload', fileBuffer, 'fileBuffer.length', fileBuffer.byteLength, typeof(fileBuffer))
    
    //arrayBuffer to base 64 string
    
    var Buffer = require('buffer/').Buffer 
    let s = Buffer.from(fileBuffer).toString('base64')
    let p = new Promise((resolve, reject) => {
      client.request_post('/api/language/upload/' + props.project_id, {base64:s}).then(res => {
        resolve();
        update()
      })
    })

    toast.promise(p, {
      loading: 'Uploading...',
      success: <b>Uploaded</b>,
      error: <b>Could not uploaded</b>,
    });
  }

  const changeCollectProd = (e) => {
    client.request_post('/api/language/collect/prod', { 
        project_id: parseInt(props.project_id), 
        language_collect_prod:e.target.checked }).then(res => {
      if (res.r) {
        setcollectProd(!e.target.checked)
        toast.success('Saved')
      } else {
        toast.error(res.msg)
      }
    })
    
  }

  return (
    <Box sx={{ width: '100%', 
        overflow:'auto', 
        height: '100%', textAlign: 'left', }}>
      <Toaster position='bottom-center' reverseOrder={false} />
      <Stack spacing={1} p={3} sx={{ height: '100%'}}>
        <Typography variant="h7">
          Language Translation
        </Typography>
        {!loading && !inited && <Box p={1}>
          <Button variant='outlined' onClick={init}>Initialize Language Translation</Button>
        </Box>}
        {!loading && inited &&  <Box>
          <Stack spacing={1} direction='row' alignItems={'center'}>
            <TextField
              label="Search"
              onChange={(e) => {
                setKeyword(e.target.value)
                filterList()}}
            ></TextField>

            {props.block_id &&
              <FormGroup>
                <FormControlLabel control={<Switch />} checked={onlyScreen} onChange={changeOnlyScreen} label="Only Block" />
              </FormGroup>}
            
            {<FormGroup>
                <FormControlLabel control={<Checkbox />} checked={showCandidate} onChange={changeCandidate} label="Candidate" />
              </FormGroup>}

            {<FormGroup>
                <FormControlLabel control={<Checkbox />} checked={untransed} onChange={changeUntransed} label="Blank" />
              </FormGroup>}

            <Button size="small" onClick={(e) => { setAnchorEl(e.currentTarget); setPopupLabel('Key'); setButtonName('add row'); setOpen(true);}}>Add Row</Button>
            <Button size="small" onClick={(e) => { setAnchorEl(e.currentTarget); setPopupLabel('Language Code ex)ko en'); setButtonName('add'); setOpen(true); }}> Add Language</Button>
            <Button size="small" onClick={(e) => { setAnchorEl(e.currentTarget); setPopupLabel('Language Code ex)ko en'); setButtonName('remove'); setOpen(true); }}> Remove Language</Button>
            <Button size="small" onClick={(e) => { csv_download() }}>Download</Button>
            <input 
              ref={fileInput} 
              type="file" 
              style={{ display: 'none' }} 
              onChange={(e) => { csv_upload(e.target.files) }}
            />
            <Button size="small" onClick={(e) => { e.target.value = null; fileInput.current.click() }}>Upload</Button>
            
            <FormGroup>
              <FormControlLabel control={<Switch />} checked={collectProd} 
                onChange={changeCollectProd} label="Collect Prod" />
            </FormGroup>

            <Popover
              id={'popover'}
              open={open}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <Stack p={1} spacing={1}>
                <TextField
                  label={popupLabel}
                  onChange={(e) => setValue(e.target.value)}
                ></TextField>
                <Button disabled={popoverLoading} startIcon={popoverLoading && <CircularProgress size={24} />} onClick={handlePopoverAddOrRemove}>{buttonName}</Button>
              </Stack>
            </Popover>
          </Stack>
          <Box mt={1} sx={{overflow:'auto', height:'100%', width:'100%', maxWidth:'100%'}}>
            <DataGrid 
              onCellClick={(e)=>{
                if(e.field == 'block_name') {
                  navigate(`/ide/?block_id=${e.row.block_id}&language=true`)
                }
              }}
              editMode="row" 
              rows={filterList()} 
              columns={columns}
              onRowEditStop={handleRowEditStop}
              processRowUpdate={processRowUpdate}
              rowModesModel={rowModesModel}
              onRowModesModelChange={handleRowModesModelChange}
            />
          </Box>
        </Box>}

      </Stack>
    </Box>
  )
}
